import styled, { useTheme } from "styled-components";
import { Gap } from "../styles/Utils";
import AppLogo from "./svgs/AppLogo";

interface HeaderProps {
  logoColor?: string;
  sloganImgSrc: string;
}

export default function Header({ logoColor, sloganImgSrc }: HeaderProps) {
  const theme = useTheme();
  return (
    <RootContainer>
      <AppLogo color={logoColor || theme.color.tertiaryLight} />
      <Gap $height={0.5} />
      <img src={sloganImgSrc} />
      <Gap $height={1} />
    </RootContainer>
  );
}

const RootContainer = styled.div`
  width: 70%;
  position: relative;
`;
